export class InfectedDataClassificationSize {
    'classification';
    'sizeBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classification",
            "baseName": "classification",
            "type": "DataClass",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return InfectedDataClassificationSize.attributeTypeMap;
    }
    constructor() {
    }
}
